/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import './Profile.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'
import { get, post } from '../../services/https'

import { Link, useNavigate } from 'react-router-dom'

export default function index() {
  const [name, setName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')

  const navigate = useNavigate()

  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        if (response.data.message === 'احراز هویت با موفقیت انجام شد') {
          get(`/api/front/users/${response.data.data.userId}`)
            .then(response => {
              const responseData = response.data
              if(responseData.message === 'کاربر مورد نظر یافت شد') {
                setName(responseData.data.name)
                setPhoneNumber(responseData.data.phoneNumber)
                setEmail(responseData.data.email)
              }
            }).catch(error => {
              if (error.response.data.messageFa === 'کاربری با این مشخصات یافت نشد') {
                localStorage.removeItem('token')
                navigate('/login')
              }
            })
        } else {
          navigate('/login')
        }
      }).catch(() => {
        navigate('/login')
      })
  }, [navigate])

  const exitHandler = () => {
    localStorage.removeItem('token')
    navigate('/login')
  }

  return (
    <div id='profile'>
      <Header name={'رستوران کانولی'} />
        <div className='body'>
        </div>
        <div className="scroll">
          <div className='profileTitle'>پروفایل</div>
          <div className='profileCard'>
            <div className='date'>
              {name ? name : '-'}
            </div>
            <div className="moneyValet">
              میزان اعتبار : 0
            </div>
            <Link to='/profile/user' className='item'>
              <span>اطلاعات کاربری شما</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <Link to='/profile/addresses' className='item'>
              <span>آدرس های من</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <Link to='/order' className='item'>
              <span>لیست سفارشات</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <Link to='' className='item'>
              <span>تراکنش ها</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <Link to='' className='item'>
              <span>نظرات من</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <Link to='' className='item'>
              <span>غذاهای مورد علاقه من</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <Link to='/support' className='item'>
              <span>ارتباط با تیم پشتیبانی</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <Link to='/about' className='item'>
              <span>درباره ما</span>
              <span>{'>'}</span>
            </Link>
            <hr />
            <div className='item'>
              <button onClick={exitHandler} style={{ width: 'fit-content' }}>
                خروج
              </button>
            </div>
          </div>
          <div className='version'>
            v 2.0.10
          </div>
        </div>
      <Footer page={'profile'} />
    </div>
  )
}
